<script lang="ts">
import {
  iButton,
  iButtonStyles,
  iButtonTypes,
  iButtonSizes,
  iKeyIcon,
  iKeyIconShape,
  iKeyIconType,
  iKeyIconStyle,
  iKeyIconSize,
} from '@inscribe/signal';
import { ChatContext, ChatContextType, UiMessageType } from '@/types/chat';
import { SUGGESTED_CHAT_PROMPTS_BY_CONTEXT } from '@/constants/chat';
import ChatPanelSuggestedPrompt from '@/V2/chat/components/ChatPanelSuggestedPrompt.vue';
import { PropType } from 'vue';

export default {
  name: 'ChatPanelEmptyState',
  components: { iButton, iKeyIcon, ChatPanelSuggestedPrompt },
  props: {
    currentContextType: {
      type: String as PropType<ChatContextType>,
      required: true,
    },
    contexts: {
      type: Array as PropType<ChatContext[]>,
      required: true,
    },
  },
  setup() {
    return {
      iButtonStyles,
      iButtonTypes,
      iButtonSizes,
      UiMessageType,
      iKeyIconShape,
      iKeyIconType,
      iKeyIconStyle,
      iKeyIconSize,
      SUGGESTED_CHAT_PROMPTS_BY_CONTEXT,
    };
  },
  computed: {
    displayedPrompts() {
      return SUGGESTED_CHAT_PROMPTS_BY_CONTEXT[this.currentContextType] ?? [];
    },
  },
};
</script>

<template>
  <div class="chat-empty-state d-flex flex-column">
    <!-- empty state message -->
    <div
      class="empty-state-message d-flex flex-column align-items-center justify-content-center"
    >
      <i-key-icon
        class="i-mb-4"
        icon="medium-ai-scan"
        :shape="iKeyIconShape.SQUARE"
        :type="iKeyIconType.NEUTRAL"
        :size="iKeyIconSize.LARGE"
        :icon-style="iKeyIconStyle.OUTLINE"
      />
      <div class="title i-text-button-2">Chat with your Assistant</div>
      <div class="subtitle i-text-body-2">
        Investigate fraud across customers and documents
      </div>
    </div>

    <div class="default-prompts d-flex flex-column i-gap-1">
      <chat-panel-suggested-prompt
        v-for="prompt in displayedPrompts"
        :key="prompt.prompt"
        :prompt="prompt"
        :contexts="contexts"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.chat-empty-state {
  height: 100%;

  .title {
    color: var(--text-neutral-bold);
  }

  .subtitle {
    color: var(--text-neutral);
  }

  .empty-state-message {
    flex: 1;
  }

  .default-prompts {
    $radius: 20px;

    .chat-panel-suggested-prompt {
      &:first-of-type {
        border-top-left-radius: $radius;
        border-top-right-radius: $radius;
      }
      &:last-of-type {
        border-bottom-left-radius: $radius;
        border-bottom-right-radius: $radius;
      }
    }
  }
}
</style>
